import React from 'react';
import './Background.css';

function Background({ image, children }) {
  const backgroundStyle = {
    backgroundImage: `url(${image})`,
  };

  return (
    <div className="background" style={backgroundStyle}>
      {children}
    </div>
  );
}

export default Background;

/*{children}: Renders the child elements (Header and content) inside the Background component. This way, the background image is positioned behind them.*/